import type { AuthenticatedUser, UserRole } from '@emazy/shared-types';

export const roleLabels: Record<UserRole, string> = {
  customer: 'Customer',
  admin: 'Admin',
  workshop: 'Workshop',
};

export function hasAnyRole(user: AuthenticatedUser, allowedRoles: readonly UserRole[]) {
  return allowedRoles.some((role) => user.roles.includes(role));
}
